import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

export type MarkdownImage = {
  id: string;
  encodedImage: string;
};

export type MarkdownImageCollection = {
  id: string;
  images: MarkdownImage[];
};

type ConvertToMarkdownResponse = {
  dataUploadFile: UploadedFile;
  markdown: string;
  extractedImagesCollection: MarkdownImageCollection | null;
};

type ConvertToMarkdownPayload = {
  location: string;
  collectionToAttachImagesTo?: string;
};

export const useConvertToMarkdownMutation = () => {
  const { mutateAsync, error, isLoading, reset } = useMutation<
    { data: ConvertToMarkdownResponse },
    Error,
    { companyId: string; payload: ConvertToMarkdownPayload }
  >({
    mutationFn: ({ companyId, payload }) =>
      api.post<ConvertToMarkdownResponse>(
        `admin/companies/${companyId}/templates/convert-to-markdown`,
        payload,
      ),
  });

  const convertToMarkdown = async (companyId: string, payload: ConvertToMarkdownPayload) => {
    const result = await mutateAsync({ companyId, payload });
    return result.data;
  };

  return {
    convertToMarkdown,
    error,
    isLoading,
    reset,
  };
};
